<template>
    <div class="ind-pack">
        <div class="row-pack">
            <BasicInformation class="col-left"
                              :basicInf="basicInf"
                              :statistics="statistics"></BasicInformation>
            <Consumption class="col-right"
                         :expenseObj="expenseObj"></Consumption>
        </div>
        <div class="row-pack">
            <div class="col-left">
                <Cost :statistics="statistics"></Cost>
                <CloudProduct :products="products"
                              :productTypeList="productTypeList"></CloudProduct>
                <RecommendProduct style="margin-top: 10px;"
                                  :productTypeList="productTypeList"
                                  :ids="productIds"></RecommendProduct>
            </div>
            <div class="col-right">
                <MsgCenter></MsgCenter>
                <Announcement></Announcement>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/service/api'
import BasicInformation from './components/basicinformation'
import Cost from './components/cost'
import Consumption from './components/consumption'
import CloudProduct from './components/cloudproduct'
import RecommendProduct from './components/recommendproduct'
import MsgCenter from './components/msgcenter'
import Announcement from './components/announcement'
export default {
    name: 'individualDashboard',
    components: {
        BasicInformation,
        Cost,
        Consumption,
        CloudProduct,
        RecommendProduct,
        MsgCenter,
        Announcement
    },
    data () {
        return {
            inf: {
                recharge: {},
                bill: {},
                order: {}
            },
            productTypeList: [],
            basicInf: {},
            statistics: [],
            productIds: {},
            expenseObj: {},
            products: {
                ModelAtrs: {},
                computes: {},
                others: []
            }
        }
    },
    mounted () {
        this.initData()
        this.getProducts()
    },
    methods: {
        getProducts () {
            this.axios.get(this.urlFormat(API.GET_CODE_DATA + '/FEATURED_PRODUCTS_CODE', true)).then(res => {
                this.productTypeList = []
                res.forEach(r => {
                    this.productTypeList.push(r.codeValue)
                })
            })
        },
        initData () {
            // 传入账户id
            const params = {
                userSid: this.$store.state.user.currentUser.info.userSid
            }
            this.axios.get(this.urlFormat(API.DASH_BILLING_ACCOUNT_OVERVIEW), { params }).then(res => {
                this.basicInf = res.user
                this.statistics = res.waitingCenter
                this.productIds = res.product
                this.expenseObj = {
                    currentMonthExpense: res.overViews.currentMonthExpense,
                    historyExpense: res.overViews.historyExpense,
                    lastMonthExpense: res.overViews.lastMonthExpense
                }

                this.categoryProducts(res.overViews.countVOS || [])
            })
        },
        categoryProducts (products) {
            const productMaps = {
                ModelAtrs: {},
                computes: {},
                others: []
            }
            products.forEach(item => {
                const { catalogName, services } = item
                if (services.length) {
                    if (catalogName === 'EI企业智能') {
                        productMaps.ModelAtrs = item
                    } else if (catalogName === '计算') {
                        productMaps.computes = item
                    } else {
                        productMaps.others.push(item)
                    }
                }
            })
            this.products = productMaps
        }
    }
}
</script>
<style lang="less">
body {
    .ind-pack {
        padding: 15px;
        .row-pack {
            display: flex;
            margin-bottom: 10px;
            .col-left {
                flex-grow: 1;
                // border: 1px solid red;
            }
            .col-right {
                width: 29.2682%;
                margin-left: 10px;
                flex-shrink: 0;
                // border: 1px solid black;
            }
        }
        .card {
            background-color: #fff;
        }
        .title {
            font-size: 12px;
            padding: 10px 15px;
            line-height: 20px;
            font-weight: 600;
        }
    }
}
</style>
